module.exports = __webpack_public_path__ + "img/pr-1.76c4d257.png";